
namespace GeniuzPOS.InitialData {

    @Serenity.Decorators.registerClass()
    export class PsCurrencyDialog extends Serenity.EntityDialog<PsCurrencyRow, any> {
        protected getFormKey() { return PsCurrencyForm.formKey; }
        protected getIdProperty() { return PsCurrencyRow.idProperty; }
        protected getLocalTextPrefix() { return PsCurrencyRow.localTextPrefix; }
        protected getNameProperty() { return PsCurrencyRow.nameProperty; }
        protected getService() { return PsCurrencyService.baseUrl; }
        protected getDeletePermission() { return PsCurrencyRow.deletePermission; }
        protected getInsertPermission() { return PsCurrencyRow.insertPermission; }
        protected getUpdatePermission() { return PsCurrencyRow.updatePermission; }

        protected form = new PsCurrencyForm(this.idPrefix);

    }
}